<template>
  <el-form ref="loginForm" :model="form" :rules="rules" label-width="0" size="large" @keyup.enter="login">
    <el-form-item prop="account">
      <el-input v-model="form.account" prefix-icon="el-icon-user" auto-complete="off" clearable
                :placeholder="$t('login.userPlaceholder')">
      </el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input v-model="form.checkPass" prefix-icon="el-icon-lock" auto-complete="off" clearable show-password
                :placeholder="$t('login.PWPlaceholder')"></el-input>
    </el-form-item>
    <el-form-item prop="verifyCode" v-if="captchaEnabled">
      <div class="login-msg-yzm">
        <el-input
          v-model="form.verifyCode"
          auto-complete="off"
          placeholder="验证码"
          prefix-icon="el-icon-lollipop"
          @keyup.enter.native="login"
        >
        </el-input>
        <img :src="codeUrl" @click="getCode"/>
      </div>
    </el-form-item>
    <el-form-item style="margin-bottom: 10px;">
      <el-col :span="12">
        <el-checkbox style="font-size: 14px;" :label="$t('login.rememberMe')" v-model="form.autologin"></el-checkbox>
      </el-col>
      <el-col :span="12" class="login-forgot">
        <router-link to="/forget">{{ $t('login.forgetPassword') }}？</router-link>
      </el-col>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width: 100%;" :loading="islogin" round @click="login">{{
          $t('login.signIn')
        }}
      </el-button>
    </el-form-item>
    <div class="login-reg">
      {{ $t('login.noAccount') }}
      <router-link to="/register">{{ $t('login.createAccount') }}</router-link>
    </div>
  </el-form>
</template>

<script>
import UserApi from '@/api/user.js';
import {setCookie, setSessionStorage} from '@/utils/base.js';

export default {
  data() {
    return {
      codeUrl: "",
      // 验证码开关
      captchaEnabled: true,
      form: {
        /*用户名*/
        account: '',
        /*密码*/
        checkPass: '',
        /*验证码*/
        verifyCode: '',
        /*验证码key*/
        verifyKey: '',
        autologin: false
      },
      rules: {
        account: [
          {required: true, message: this.$t('login.userError'), trigger: 'blur'}
        ],
        checkPass: [
          {required: true, message: this.$t('login.PWError'), trigger: 'blur'}
        ],
        verifyCode: [
          {required: true, message: this.$t('login.PWError'), trigger: 'blur'}
        ]
      },
      islogin: false,
    }
  },
  watch: {
    userType(val) {
      if (val == 'admin') {
        this.form.user = 'admin'
        this.form.password = 'admin'
      } else if (val == 'user') {
        this.form.user = 'user'
        this.form.password = 'user'
      }
    }
  },
  mounted() {
    this.getCode();
  },
  methods: {
    getCode() {
      let self = this;
      UserApi.getCodeImg({width: 130, height: 40})
        .then(res => {
          self.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled;
          if (self.captchaEnabled) {
            self.codeUrl = res.data.base64;
            self.form.verifyKey = res.data.key;
          }
        });
    },
    /*登录方法*/
    async login() {
      var validate = await this.$refs.loginForm.validate().catch(() => {
      })
      if (!validate) {
        return false
      }

      this.islogin = true;
      var Params = {
        username: this.form.account,
        password: this.form.checkPass,
        verifyCode: this.form.verifyCode,
        verifyKey: this.form.verifyKey,
      };
      /*调用登录接口*/
      UserApi.login(Params, true)
        .then(res => {
          this.islogin = false;
          if (res.code == 200) {
            /*保存个人信息*/
            setCookie('userinfo_supplier', res.data.loginSupplierUserVo.userName);
            setCookie('token_supplier', res.data.token);
            /*设置一个登录状态*/
            setCookie('isLogin_supplier', true);
            /*跳转到首页*/
            this.$router.push({path: '/'});
          } else {
            this.$message({
              message: '登录失败',
              type: 'error'
            });
          }
        })
        .catch(error => {
          //接口调用方法统一处理
          this.islogin = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/login/components/passwordForm.vue